import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { BaseUtils } from '../core/baseUtils.service';

@Injectable()

export class PageNotFoundService {
  errorStatus: number;
  constructor(
    public router: Router,
    public messageService: MessageService,
    public translate: TranslateService,
    public baseUtils: BaseUtils
  ) {
  }

  /**
   * Server error handler based on error type
   * @param error Server error
   */
  errorHandler(error: HttpErrorResponse, type) {
    let errorMessage = '';
    let errorExist: any;
    let errorCode: number;
    this.errorStatus = error.status;
    if (type === 'UPLOAD_ERROR' || type === 'PERMISSION_ERROR') {
      errorExist = error; errorCode = error.status;
    } else {
      errorExist = error.error; errorCode = error.status;
    }
    if (errorExist && errorCode === 401) {
      errorMessage = this.translate.instant('MESSAGES.SESSION_EXPIRE');
      localStorage.removeItem('loggedInUser');
      this.router.navigate(['login']);
    } else if (errorExist && errorCode === 500) {
      errorMessage = this.translate.instant('MESSAGES.INTERNAL_SERVER_ERROR');
    } else if (errorExist && errorCode === 422) {
      errorMessage = this.create422error(errorExist, type);
    } else if (errorExist && errorCode === 409) {
      errorMessage = this.create409error(errorExist, type);
    } else if (errorExist && errorCode === 404) {
      errorMessage = this.translate.instant('COMMON.NO_RESULT_FOUND');
    } else if (errorExist && errorCode === 403) {
      errorMessage = this.translate.instant('MESSAGES.AUTHORIZED');
    } else if (((errorExist && errorCode === 400) || errorCode === 400) || (errorExist && errorCode === 405)) {
      errorMessage = errorExist ? errorExist.message : this.translate.instant('MESSAGES.TRY_AGAIN');
    }
    this.errorNotification(error, errorMessage);
  }

  /**
   * To create 409 error message
   * @param error Error
   * @param type Page based error
   */
  create409error(error, type) {
    let message = '';
    if (type === 'ADD_USER') {
      message = this.translate.instant('MESSAGES.ACCOUNT_ALREADY_EXIST');
    } else if (type === 'ACCESS_GROUP') {
      message = this.translate.instant('MESSAGES.ACCESS_GROUP_EXIST');
    } else if (type === 'CONNECTOR') {
      const connectorExist = 'Connector of type';
      if (error.message.indexOf(connectorExist) === 0) {
        message = this.translate.instant('MESSAGES.CONNECTOR_EXIST');
      } else {
        message = this.translate.instant('MESSAGES.CONNECTOR_USERNAME_EXIST');
      }
    } else {
      message = error.message;
    }
    return message;
  }

  /**
   * To create 422 error message
   * @param error Error
   * @param type Page based error
   */
  create422error(error, type) {
    let message = '';
    if (type === 'ADD_USER') {
      message = this.translate.instant('MESSAGES.ACCOUNT_ALREADY_EXIST');
    } else {
      message = error.message;
    }
    return message;
  }

  /**
   * To display error
   * @param error Error
   * @param errorMessage Error message
   */
  errorNotification(error, errorMessage) {
    if (error.statusText === 'Unknown Error') {
      this.baseUtils.toasterMessageAction('error', 'Connection to the server unsuccessful, please log in again', '');
    } else {
      this.baseUtils.toasterMessageAction('error', errorMessage, '', false);
    }
  }

}
